export default __webpack_public_path__ + "static/mo-025d3a9d23723c03f1656d69bf2acae9.svg";